import {mapMutations} from "vuex";

export default {
    name: "product-card",
    components: {},
    props: {
        item: {
            type: Object,
            default:()=>{}
        }
    },
    data() {
        return {}
    },
    created() {
    },
    computed: {},
    methods: {
        ...mapMutations({

        })
    }
}
